import { combineReducers } from 'redux';

import products from '@lib/core/products/slices/products';
import productSets from '@lib/core/products/slices/productSets';

export const productsRoot = combineReducers({
  productSets,
  products,
});
